export default __webpack_public_path__ + "static/media/sambusavg.4233050d.jpg";